var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "report-create-wrap" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 20, offset: 4 } },
            [
              _c(
                "el-form",
                {
                  ref: "addForm",
                  staticClass: "report-create-form",
                  attrs: {
                    "label-position": "right",
                    model: _vm.addForm,
                    rules: _vm.rules,
                    "label-width": "180px"
                  }
                },
                [
                  _c("el-form-item", { attrs: { label: "报备类型：" } }, [
                    _c("span", { staticClass: "fs-13" }, [_vm._v("延迟发货")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "延迟发货原因：", prop: "report_reason" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "400px" },
                          attrs: { clearable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.addForm.report_reason,
                            callback: function($$v) {
                              _vm.$set(_vm.addForm, "report_reason", $$v)
                            },
                            expression: "addForm.report_reason"
                          }
                        },
                        _vm._l(_vm.reasonList, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { value: item.value, label: item.label }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "备注：", prop: "report_detailed_reason" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          type: "textarea",
                          maxlength: "50",
                          clearable: "",
                          placeholder:
                            "请输入报备原因，有助于审核通过，最多不超过50个字"
                        },
                        model: {
                          value: _vm.addForm.report_detailed_reason,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "report_detailed_reason", $$v)
                          },
                          expression: "addForm.report_detailed_reason"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "受影响订单：", prop: "orderList" } },
                    [
                      _c("effectOrderList", {
                        attrs: { ids: _vm.report_ids, pageType: _vm.pageType },
                        on: {
                          showOrder: _vm.showOrder,
                          exportOrder: _vm.exportOrder,
                          resetOrderIds: _vm.resetOrderIds
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "预计发货日：", prop: "report_delay_day" }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "400px" },
                        attrs: {
                          type: "date",
                          placeholder: "请选择日期",
                          "value-format": "yyyy-MM-dd",
                          pickerOptions: _vm.pickerOptions
                        },
                        model: {
                          value: _vm.addForm.report_delay_day,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "report_delay_day", $$v)
                          },
                          expression: "addForm.report_delay_day"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "create-tips" }, [
                    _c("span", [_vm._v("*")]),
                    _vm._v(
                      "\n          温馨提示：所选择的订单均需要在【预计发货日】之前发出，不包含【预计发货日】当天，若商家未按照报备时间履约，则属于二次违约，相关责任需由商家自行承担。\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "上传凭证：", prop: "filesList" } },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "uploadImg",
                          staticClass: "img-upload",
                          attrs: {
                            action: "",
                            headers: _vm.headers,
                            "list-type": "picture-card",
                            "auto-upload": true,
                            limit: 3,
                            "before-upload": _vm.beforeAvatarUpload,
                            "on-exceed": _vm.exce,
                            "http-request": _vm.httpRequest,
                            "on-remove": _vm.handleRemove,
                            "file-list": _vm.fileList,
                            disabled: _vm.pageType == "check"
                          }
                        },
                        [_c("i", { staticClass: "el-icon-plus" })]
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "仅支持上传jpg、png格式图片，图片大小不得超过5M，最多上传3张。"
                        )
                      ]),
                      _vm._v(" "),
                      _vm.resetNum != undefined
                        ? _c("div", { staticStyle: { color: "red" } }, [
                            _vm._v(
                              "\n            *今天最多还能上传" +
                                _vm._s(_vm.resetNum) +
                                "张图片！\n          "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.pageType == "create" || _vm.pageType == "edit"
                    ? _c(
                        "div",
                        { staticClass: "flex-row-center-center action-btns" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "default-btn",
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.handleSubmit(0)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            保存草稿，返回上一页\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { margin: "0 40px" },
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.onSubmit("addForm")
                                }
                              }
                            },
                            [_vm._v("\n            提交\n          ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "default-btn",
                              attrs: { type: "primary" },
                              on: { click: _vm.resetForm }
                            },
                            [_vm._v("\n            不保存，取消\n          ")]
                          )
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "action-btns",
                          staticStyle: { "text-align": "center" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "default-btn",
                              attrs: { type: "primary" },
                              on: { click: _vm.resetForm }
                            },
                            [_vm._v("\n            返回上一页\n          ")]
                          )
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("effectOrderDialog", {
        ref: "childDialog",
        attrs: { selectAllIds: this.report_ids },
        on: { setOrderIds: _vm.setOrderIds }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c296c61", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c296c61","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/orderReport/reportCenter/create.vue
// module id = null
// module chunks = 